<style lang="scss" scoped>
  .order-table {
    width: 100%;

    .cell-actions {
      width: 120px;
    }
  }
</style>

<template>
  <div>
    <div class="fz24 light mt2">Mine ordre</div>
    <p class="mt2 mb3">Her finner du en ovesikt over dine ordre. Klikk på en av ordrene for å f.eks. laste opp nye filer.</p>
    <div v-if="orders">
      <div class="card rounded sh1" v-if="orders.length > 0">
        <table class="order-table" cellpadding="0" cellspacing="0">
          <thead>
          <tr class="text-grey ">
            <th class="border-bottom border-light-grey py2 px3 light left-align">Bestilling</th>
            <th class="border-bottom border-light-grey py2 light left-align">Plassert</th>
            <th class="border-bottom border-light-grey py2 light left-align" light>Total</th>
            <th class="border-bottom border-light-grey py2 light">Handlinger</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(order, index) in orders" class="@bg-light-blue">
            <td class="px3 py2">
              <div class="fz18 mb1 pointer" @click="viewOrder(order.id)">{{ order.title }}</div>
              <div v-if="order.lines_count > 1">{{ order.lines_count }} produkter</div>
              <div v-else="">{{ order.lines_count }} produkt</div>
            </td>
            <td>
              <div class="text-grey truncate">{{ toLocaleDate(order.created_at.date) }}</div>
            </td>
            <td>
              <div class="fz24 light text-blue truncate">kr {{ toLocale(order.gross_total / 100) }},-</div>
            </td>
            <td class="cell-actions center">
              <md-button class="md-icon-button text-grey" @click.native="viewOrder(order.id)">
                <md-tooltip>Se detaljer</md-tooltip>
                <md-icon>remove_red_eye</md-icon>
              </md-button>
            </td>
          </tr>
          </tbody>
        </table>

      </div>
      <div class="card rounded sh1" v-if="orders.length == 0">
        <div class="p3 center">
          <div class="fz24 light my3">Du har ikke plassert noen ordre ennå...</div>
          <md-button class="md-raised md-primary" @click.native="goToShop()">Klikk her for å handle</md-button>
        </div>
      </div>
    </div>
    <div class="p3 center" v-else>
      <md-spinner md-indeterminate></md-spinner>
    </div>
  </div>
</template>

<script>
  import apiOrder from '@/js/api/order';
  import hasPrices from '@/js/mixins/hasPrices';

  export default {
    mixins: [hasPrices],

    data() {
      return {
        orders: null,
      };
    },

    mounted() {
      // this.state.start('loading');
      apiOrder.index().then(this.onFetchSuccess);
    },

    methods: {
      onFetchSuccess(response) {
        this.orders = response.data.data;
        // this.state.stop('loading');
      },

      viewOrder(id) {
        this.$router.push({ name: 'view-order', params: { orderId: id } });
      },

      goToShop() {
        this.$router.push({ name: 'shop' });
      },

      toLocaleDate(date) {
        return moment(date).format('Do MMMM YYYY \\k\\l. HH:mm');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// MyOrders.vue?6878837c